import styled from 'styled-components';
import { rgba } from 'polished';
import { Card } from 'antd';

import * as Colors from '../../../../attrs/colors';

export const StyledCard = styled(Card)`
  margin: 0 0 1rem 0;
`;

export const Note = styled.div`
  margin-top: 1rem;
  font-size: 0.9rem;
  color: ${Colors.GREY_50};
`;

export const Title = styled.div`
  margin-bottom: 1.5rem;
  font-weight: bold;
  color: ${rgba(Colors.BLACK, 0.85)};
`;

export const FormActions = styled.div`
  margin-top: 2rem;
`;
